<app-button [disabled]="disabled">
  Volgende
  <app-icon icon="assets/arrow-right.svg"></app-icon>
</app-button>
